import { render } from "./ViewTourPart.vue?vue&type=template&id=d4044794"
import script from "./ViewTourPart.vue?vue&type=script&lang=ts"
export * from "./ViewTourPart.vue?vue&type=script&lang=ts"
script.render = render

export default script